import { Typography, useTheme } from "@mui/material";
import { DifferencePanelPopover } from "components/search/input/DifferencePanel/DifferencePanelPopover";
import { useFormatLocalDateString } from "hooks/useFormatLocalDate";
import { SearchSummary } from "store/api/generatedApi";
import { UserLabel } from "src/components/common/userLabel/UserLabel";

interface Props {
  search: SearchSummary;
  parentSearchId?: number;
}

export const HistoryChildItem = ({ search, parentSearchId }: Props) => {
  const formattedCreatedAt = useFormatLocalDateString("datetime")(
    search.created_at
  );
  const theme = useTheme();
  const content = (
    <Typography
      variant="body2"
      sx={{
        pl: 1,
        py: 0.5,
        borderLeft: 1,
        color: theme.palette.text.secondary,
      }}
    >
      {formattedCreatedAt}
      {" • "}
      <UserLabel user={search.user} variant="body2" />
    </Typography>
  );

  if (parentSearchId) {
    return (
      <DifferencePanelPopover
        targetSearchId={search.search_id}
        sourceSearchId={parentSearchId}
      >
        {content}
      </DifferencePanelPopover>
    );
  }
  return content;
};
